<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
import liquidChartable from '../../../components/liquidChartable';

export default {
  mixins: [liquidChartable],
  props: {
    // Removed.by.KWShin.2024.03.08. liquidChartable.js에 이미 선언되어 있음.
    // title: String,
    value: {
      type: Array,
      required: true,
    },
  },
  computed: {
    // BEGIN::Added.by.KWShin.2024.03.29.
    title() {
      return this.$t('dv.title.user');
    },
    // FINISH::Added.by.KWShin.2024.03.29.
  },
  watch: {
    value(data) {
      this.setData(data);
    },
  },
  data() {
    return {
      shape: 'circle',
      data: {
        value: '',
        type: 'digit',
      },
    };
  },
  methods: {
    setData(data) {
      // console.log(data);
      // BEGIN::2024.03.29.KWShin.
      // RFC는 로그인 사용자에서 무조건 제외하는 게 아니다.
      // RFC 사용자도 하나의 로그인 사용자로 집계해주어야 한다. 단, 중복은 제거한다.
      // this.data.value = data.reduce((acc, item) => (acc += !!item.type && item.type != 'RFC' ? 1 : 0), 0);
      this.data.value = data.filter((datum, index, arr) => {
        return arr.findIndex(elm => elm.bname == datum.bname && elm.instId == datum.instId) === index;
      }).length;
      // FINISH::2024.03.29.KWShin.
    },
  },
};
</script>
